// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".compiled.css?v=" + "5f61f589862437a0882a" + "";
};